import { injectIntl, FormattedMessage } from "react-intl";
import { intlShape } from "../../shapes";
import { url } from "../../utils";
import ContextualHelp from "../Contextuals/ContextualHelp";

type Props = {
  intl?: intlShape;
};

export function InstrumentationFullEmptyCalibrationHelp({ intl }: Props) {
  return (
    <ContextualHelp
      // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
      title={intl.formatMessage({ id: "label.full_empty_calibration" })}
    >
      <p className="space-after">
        <FormattedMessage id="instrumentation_full_empty_calibration_help.description" />
      </p>
      <img
        className="img-responsive"
        src={url("/images/full_empty_calibration_help.png")}
        // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
        alt={intl.formatMessage({ id: "label.full_empty_calibration" })}
      />
      {/* @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'. */}
      <h3>{`${intl.formatMessage({ id: "label.full" })} (F)`}</h3>
      <p>
        <FormattedMessage id="instrumentation_full_empty_calibration_help.full" />
      </p>
      {/* @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'. */}
      <h3>{`${intl.formatMessage({ id: "label.empty" })} (E)`}</h3>
      <p>
        <FormattedMessage id="instrumentation_full_empty_calibration_help.empty" />
      </p>
      {/* @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'. */}
      <h3>{`${intl.formatMessage({ id: "label.block_distance" })} (BD)`}</h3>
      <p>
        <FormattedMessage id="instrumentation_full_empty_calibration_help.block_distance" />
      </p>
      {/* @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'. */}
      <h3>{`${intl.formatMessage({ id: "label.sensitivity" })}`}</h3>
      <p>
        <FormattedMessage id="instrumentation_full_empty_calibration_help.sensitivity" />
      </p>
    </ContextualHelp>
  );
}

export default injectIntl(InstrumentationFullEmptyCalibrationHelp);
